import React from "react";
import { labelCN } from "./styles";

type Props = {
  value: string[];
  label: string;
};

export default function ActionUploadFilesetCollapsed(props: Props) {
  const { value, label } = props;

  return (
    <div>
      <div className={labelCN}>{label}</div>
      {value.map((v, i) => (
        <a key={i} href={v}>
          {v}
        </a>
      ))}
    </div>
  );
}
